import { useContext } from "react";
import { Redirect } from "react-router-dom";
import InfoContext from "utils/context/info-context";
import useAuth from "utils/hooks/useAuth";

export const AuthGuard = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();
  const info = useContext(InfoContext);
  const isAdmin = auth && info ? (info.accubation.find((accubation) => accubation === auth.uid) ? true : false) : false;
  return <>{auth !== null ? isAdmin ? <Redirect to="/admin" /> : <>{children}</> : <Redirect to="/join" />}</>;
};
export const AdminAuthGuard = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();
  const info = useContext(InfoContext);
  const isAdmin = auth && info ? (info.accubation.find((accubation) => accubation === auth.uid) ? true : false) : false;
  return <>{auth !== null ? isAdmin ? <>{children}</> : <Redirect to="/home" /> : <Redirect to="/join" />}</>;
};

export const GuestGuard = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();
  return <>{auth === null ? <>{children}</> : <Redirect to="/home" />}</>;
};
